// Module
var code = `<template> <div class="partial-require-ghg-verification-review row"> <lookup-control class="col-12 col-sm-6 col-lg-6 margin-bottom col-gutter" label="What information are you requesting?" parameters="6" query="RS_SubtaskTypes" placeholder="Select" selected-value.two-way="meta.subtaskTypeId"></lookup-control> </div> </template>`;
// Exports
module.exports = code;